import { useQuery } from '@tanstack/react-query';

import { FAQ_TYPE_CLIENT_COURTIER, FAQ_TYPE_CLIENT_DIRECT } from '@/lib/constants';
import { getData } from '@/lib/api/client-v2';
import { hasOnlyContractApporteur43397 } from '@/lib/contracts';
import { queryKeys } from '@/lib/query-keys';
import { ENDPOINTS } from '@/types/api/endpoints';
import type { Faq } from '@/types/api/faq';

import { useContracts } from '@/hooks/api/use-contracts';

/** Type de FAQ selon la clientèle : directe (tous les contrats en apporteur 43397) ou courtier. */
export const getFaqType = (contracts: Parameters<typeof hasOnlyContractApporteur43397>[0]): number =>
    hasOnlyContractApporteur43397(contracts) ? FAQ_TYPE_CLIENT_DIRECT : FAQ_TYPE_CLIENT_COURTIER;

/**
 * Questions de la FAQ pour le type de clientèle de l'utilisateur (`GET /faq?faq_type=`).
 *
 * L'ancien écran rechargeait la FAQ à chaque montage : on garde ce comportement. Le type de FAQ
 * dépend des contrats : on attend leur lecture (réussie ou non) pour ne pas interroger le Pass
 * avec un type provisoire.
 */
export const useFaq = () => {
    const contracts = useContracts();
    const faqType = getFaqType(contracts.data?.data);

    return useQuery({
        queryKey: queryKeys.faq(faqType),
        queryFn: () => getData<Faq[]>(ENDPOINTS.faq, { faq_type: faqType }),
        enabled: !contracts.isPending,
        refetchOnMount: 'always',
    });
};

/** Questions mises en avant (`home`). */
export const getTopFaq = (faqs: Faq[] = []) => faqs.filter((faq) => faq.home);

/** Questions d'une catégorie (1 contrat, 2 sinistre, 3 autre, 4 documents, 5 trottinette, 6 VAE, 7 parrainage). */
export const getFaqByCategory = (faqs: Faq[] = [], categoryId: number) => faqs.filter((faq) => faq.category.id === categoryId);
